import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

interface CarAvailabilityDialogProps {
  open: boolean;
  onClose: () => void;
  isAvailable: boolean | null;
  carPlateNumber: string | null;
  affectedTrip?: any;
  loading?: boolean;
  error?: string | null;
}

const CarAvailabilityDialog: React.FC<CarAvailabilityDialogProps> = ({
  open,
  onClose,
  isAvailable,
  carPlateNumber,
  affectedTrip
}) => {

    const shouldOpen = open && isAvailable === false;
    // Only show dialog when car is NOT available
    if (isAvailable) {
        return null;
    }
  return (
    <Dialog open={shouldOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <Box textAlign="center" py={1}>
             <ErrorIcon sx={{ fontSize: 64, color: 'error.main', mb: 1.5}} />
          {/* {isAvailable ? (
            <CheckCircleIcon sx={{ fontSize: 64, color: 'success.main', mb: 1.5 }} />
          ) : (
            <ErrorIcon sx={{ fontSize: 64, color: 'error.main', mb: 1.5}} />
          )} */}
          
          <Typography variant="h6" gutterBottom>
            {/* {isAvailable ? 'Car Available' : 'Car Not Available'} */}
            Car Not Available
          </Typography>
          
          {carPlateNumber && (
            <Chip 
              label={carPlateNumber} 
              color={isAvailable ? 'success' : 'error'}
              sx={{ mt: 0.5, fontWeight: 'bold' }}
            />
          )}
          
          {/* {!isAvailable && affectedTrip && ( */}
          {affectedTrip && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Already booked for Trips: <strong>{affectedTrip}</strong>
            </Typography>
          )}
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button variant="contained" onClick={onClose} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CarAvailabilityDialog;